import { Injectable, OnInit } from '@angular/core';
import { environment } from '../../Environments/environment.prod';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BaseApiService } from '../../Shared/utilities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PatientPortalAPI extends BaseApiService {
  private baseUrl = environment.apiUrl;
  private getHeader() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
  }

  constructor(private http: HttpClient) {
    super();
  }

  GetValidatePatientPortalLoginToken(token: string): Observable<any> {
    const params = new HttpParams().set('token', token);
    return this.http.get(`${this.baseUrl}/Patient/GetValidatePatientPortalLoginToken`, { params, ...this.getHeader() });
  }

  getParentSubOrganizationIdByBranchId(OrganizationId: any): Observable<any> {
    const key = `parentSubOrgId_byBranchId_${OrganizationId}`;
    return this.getCachedRequest(key, this.http.get(`${this.baseUrl}/MasterPatient/getParentSubOrganizationIdByBranchId`, { params: new HttpParams().set('BranchId', OrganizationId.toString()), ...this.getHeader() }))
  }

  getCountries(): Observable<any> {
    return this.getCachedRequest(
      'countries_all',
      this.http.get(`${this.baseUrl}/MasterData/GetAllCountries`)
    );
  }

  getOrgLogoByOrganizationId(OrganizationId: number): Observable<any> {
    const key = `portal_logo_${OrganizationId}`;
    return this.getCachedRequest(key, this.http.get(`${this.baseUrl}/MasterPatient/getPoratalLogoByOrganizationId`, { params: new HttpParams().set('OrganizationId', OrganizationId.toString()) }))
  }

  validatePatientLogin(params: any): Observable<any> {
    const param = `'${JSON.stringify(params)}'`;
    return this.http.post(`${this.baseUrl}/Patient/ValidatePatientLogin`, param, this.getHeader());
  }

  ValidatePatientQRAppOTP(ReqObj: { reqMobileNo?: string; Otp?: string; ParentOrganizationId?: number }) {
    const params = new HttpParams()
      .set('MobileNumber', ReqObj.reqMobileNo ?? '')
      .set('OTP', ReqObj.Otp ?? '')
      .set('ParentOrganizationId', String(ReqObj.ParentOrganizationId ?? ''));

    return this.http.get(
      `${this.baseUrl}/MasterPatient/ValidatePatientQRAppOTP`,
      { params }
    );
  }

  USAddUpdatePatientSignUp(params: any): Observable<any> {
    const param = `'${JSON.stringify(params)}'`;
    return this.http.post(`${this.baseUrl}/Patient/USAddUpdatePatientSignUp`, param, this.getHeader());
  }

  GetValidatePatientPortalCredentials(params: any): Observable<any> {
    const param = `'${JSON.stringify(params)}'`;
    return this.http.post(`${this.baseUrl}/Patient/GetValidatePatientPortalCredentials`, param, this.getHeader());
  }

  AddUpdatePatientPassword(params: any): Observable<any> {
    const param = `'${JSON.stringify(params)}'`;
    return this.http.post(`${this.baseUrl}/Patient/AddUpdatePatientPassword`, param, this.getHeader());
  }

  GetLatestAppointmentsBySelectedDates(params: any): Observable<any> {
    const param = `'${JSON.stringify(params)}'`;
    return this.http.post(`${this.baseUrl}/AppointmentPlugin/GetLatestAppointmentsBySelectedDates`, param, this.getHeader());
  }

  GetpatientAscSummary(params: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/Surgery/GetpatientAscSummary`, params, this.getHeader());
  }

  GetPatientAllAppointmentDataExportInfo(params: any): Observable<any> {
    const param = `'${JSON.stringify(params)}'`;
    return this.http.post(`${this.baseUrl}/Consultation/GetPatientAllAppointmentDataExportInfo`, param, this.getHeader());
  }

  getBranchSubSpecializationsById(params: any): Observable<any> {
    const key = `branch_sub_spec_${JSON.stringify(params)}`;
    return this.getCachedRequest(
      key,
      this.http.post(`${this.baseUrl}/MasterAdmins/GetBranchSubSpecializationsById`, params, this.getHeader())
    );
  }

  getAllUsersByDepartmentId(params: any): Observable<any> {
    const key = `users_by_dept_${JSON.stringify(params)}`;
    return this.getCachedRequest(
      key,
      this.http.post(`${this.baseUrl}/MasterAdmins/GetAllUsersByDeptId`, params, this.getHeader())
    );
  }
  GetInventoryMasterIOLData(params: any): Observable<any> {
    const key = `inventory_iol_${params.ParentOrganizationId}`;
    return this.getCachedRequest(
      key,
      this.http.get(`${this.baseUrl}/HInventory/GetInventoryMasterIOLData?ParentOrganizationId=` + params.ParentOrganizationId)
    );
  }

  GetFaxImgs3Url(params: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/Patient/GetFaxImgs3Url`, params, this.getHeader());
  }

  GetPatientConsultationDetailsByApptId(params: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/Consultation/GetPatientConsultationDetailsByApptId`, params, this.getHeader());
  }

  SendReferalToMail(params: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/Consultation/SendReferalToMail`, params, this.getHeader());
  }

  GetCCDACreate(params: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/Consultation/GetCCDACreate`, params, this.getHeader());
  }

  GetPatientOrderInterpretationDetailsByVisitId(params: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/Patient/GetPatientOrderInterpretationDetailsByVisitId`, params, this.getHeader());
  }

  GetPatientImageStudyDetailsById(params: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/Patient/GetPatientImageStudyDetailsById`, params, this.getHeader());
  }

  GetMedicalHistoryProfileByPatientId(params: any): Observable<any> {
    const key = `medical_history_patient_${params}`;
    return this.getCachedRequest(
      key,
      this.http.get(`${this.baseUrl}/Consultation/GetMedicalConditonHistoriesByPatientId?PatientId=` + params)
    );
  }

  AppointmentReasonRemarks(params: any): Observable<any> {
    const param = `'${JSON.stringify(params)}'`;
    return this.http.post(`${this.baseUrl}/Patient/AppointmentReasonRemarksFrompatientPortal`, param, this.getHeader());
  }

  GetDoctorsByOrganizationCode(orgCode: string): Observable<any> {
    const params = new HttpParams().set('OrganizationCode', orgCode);
    return this.http.get(
      `${this.baseUrl}/AppointmentPlugin/GetDoctorsByOrganizationCode`,
      { params, ...this.getHeader() }
    );
  }

  SaveReferralAppointmentRequest(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/Patient/SaveReferralAppointmentRequest`, payload, this.getHeader());
  }


  // Logs
  AddUpdatePatientPortalLogs(params: any): Observable<any> {
    const param = `'${JSON.stringify(params)}'`;
    return this.http.post(`${this.baseUrl}/MasterData/AddUpdatePatientPortalLogs`, param, this.getHeader());
  }

  GetAllMasterConsultationData(): Observable<any> {
    return this.getCachedRequest(
      'master_consultation_data',
      this.http.get(`${this.baseUrl}/MasterData/GetAllMasterConsultationData`, this.getHeader())
    );
  }

  ValidatePatientAppOTP(params: any): Observable<any> {
    const queryParams =
      `MobileNumber=${encodeURIComponent(params.reqMobileNo)}` +
      `&OTP=${params.Otp}` +
      `&SubOrganizationId=${params.SubOrganizationId}`;

    return this.http.get(
      `${this.baseUrl}/MasterPatient/USValidatePatientAppOTPForWeb?${queryParams}`
    );
  }

  GetOperativeNotesDetails(params: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/Surgery/GetOperativeNotesDetails`, params, this.getHeader()
    );
  }

  getPatientASCDrawingPadImages(params: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/Consultation/getPatientASCDrawingPadImages`, params, this.getHeader()
    );
  }
  GetPostOpDischargeData(params: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/Surgery/GetPostOpDischargeData`, params, this.getHeader()
    );
  }
  private baseUrl1 = 'https://ehrusdevapi.azurewebsites.net/api/';
  AddUserDeviceDetails(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl1}Patient/AddUserDeviceDetails`, payload);
  }

  GetPatientDeviceDetails(patientId: number): Observable<any> {
    return this.http.get(`${this.baseUrl1}Patient/GetPatientDeviceDetails?PatientId=${patientId}`);
  } 

  GetAllDepositsByPatient(param: any): Observable<any> {
    return this.http.get(`${this.baseUrl}/Patient/GetAllDepositsByPatient`, { ...this.getHeader(), params: param });
  }
  UpdatePatientDeviceDetails(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/Patient/UpdatePatientDeviceDetails`, payload);
  }
}

 

